import React, { Component } from "react";
import DataTable from 'react-data-table-component';
import history from "../login/history";
import ButtonLink from "../../generico/ButtonLink";
import authService from "../../../services/login/auth.service";
import ConfigService from "../../../services/configuracion/ConfigService";
import { PrestamoCuota } from "./PrestamoCuota";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoneyBill } from "@fortawesome/free-solid-svg-icons";
import { trackPromise } from "react-promise-tracker";
import PrestamoInmediatoService from "../../../services/solicitudes/PrestamoInmediatoService";
import { reemplazarPunto } from "../../generico/utils/FormatoInput";
import PrestamoPreaprobadoServices from "../../../services/solicitudes/PrestamoPreaprobadoService"



const paginationOptions = {
  rangeSeparatorText: "de",
  rowsPerPageText: 'Filas por página',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todos'
  //noRowsPerPage:true
};

const PAGAR_PRESTAMO = 70;

export default class Prestamo extends Component {
  constructor(props) {
    super(props);
     this.state = {
    autorizador: sessionStorage.getItem("autorizador") || null
  };
    
  }
  componentDidMount() {
    this.PrestamoPreaprobadoBanner();
  // leer valor actual de sessionStorage al montarse
  const autorizador = sessionStorage.getItem("autorizador") || null;
  this.setState({ autorizador });

  // escuchar cambios futuros
  window.addEventListener("autorizadorChange", this.handleAutorizadorChange);
}
  PrestamoPreaprobadoBanner = () => {

        trackPromise(
            PrestamoPreaprobadoServices.getLineaCredito().then((response) => {

                var data = JSON.stringify(response.data);
                var jsonData = JSON.parse(data);
                if (jsonData.codigoRetorno === "0") {
                     this.obtenerAutorizador (jsonData.datos.idLinea); 
                }
            }).catch(function (error) {
                authService.logout();
            })
        );
    }
    obtenerAutorizador = (idLinea) => {
      const socioStr = sessionStorage.getItem("socio");
      const socio = socioStr ? JSON.parse(socioStr) : null;
      if (!socio) return;
    
      trackPromise(
        PrestamoPreaprobadoServices.getAutorizadorPrestamoInmediato(idLinea, socio.numeroSocio)
          .then((response) => {
            // response.data probablemente ya es un objeto
            const jsonData = response.data;
    
            if (jsonData && jsonData.codigoRetorno === "0") {
              // normalizamos exacto: string, trim y mayúscula
              const valor = String(jsonData.datos?.tieneDescSalario || '').trim().toUpperCase();
    
              // guardamos en state y en sessionStorage de forma segura
              this.setState({ autorizador: valor }, () => {
                // escribimos el valor explícito (NO this.state.autorizador sin callback)
                sessionStorage.setItem("autorizador", valor);
    
                // disparar evento custom para la misma pestaña (otros componentes lo escuchan)
                window.dispatchEvent(new CustomEvent('autorizadorChange', { detail: valor }));
              });

            }
          })
          .catch((error) => {
            console.error('error obtenerAutorizador', error);
            authService.logout();
          })
      );
    }


  getColumn() {
    return [
      {
        name: "Cuenta",
        selector: row => row.cuenta,
        width: "85px"
      },
      {
        name: "Tipo",
        selector: row => row.descripcion,
        width: "118px"
      },
      {
        name: "Moneda",
        selector: row => row.moneda,
        width: "55px"
      },
      {
        name: "Desembolso",
        selector: row => row.inicio,
        width: "100px"
      },
      {
        name: "Monto del Préstamo",
        selector: row => row.capital,
        width: "110px"
      },
      {
        name: "Saldo Capital",
        selector: row => row.saldoCapital,
        width: "110px",
        right: true
      },
      {
        name: "Amortización",
        selector: row => row.amortizado,
        width: "110px",
        right: true
      },
      {
        name: "Cuota",
        selector: row => row.cuotasPagadas,
        width: "75px"
      },
      {
        name: "Tu cuota vence el",
        selector: row => row.fechaVencimiento,
        width: "70px"
      },
      {
        name: "Último Pago",
        selector: row => row.ultimoPago,
        width: "100px"

      },
      {
        cell: (row) => (
          <div className="flex flex-col space-y-2 p-2">
            <ButtonLink
              className="btn btn-cu-terciary btn-lg btn-block"
              param={row}
              url={ConfigService.getPathById(PAGAR_PRESTAMO)?.url}
              onClick={this.pagarPrestamo}>
              <FontAwesomeIcon icon={faMoneyBill} />  Pagar
            </ButtonLink>

            {row.numeroDestino === 86 &&

              <div className="dropdown dropdownPi">
                <button className="btn btn-cu-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Documentos
                </button>
                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  {/* <span className="dropdown-item" onClick={() => { this.descargar('CONTRATO',row.cuenta) }}>Ver contrato</span>
                  <span className="dropdown-item" onClick={() => { this.descargar('LIQUIDACION',row.cuenta) }}>Ver Liquidacion</span>
                  <span className="dropdown-item" onClick={() => { this.descargar('SOLICITUD',row.idSolicitud) }}>Ver Solicitud</span> */}
                  <a className="dropdown-item" onClick={() => { this.descargar('CONTRATO', row.cuenta, row.capital) }} href="#">Ver Contrato</a>
                  <a className="dropdown-item" onClick={() => { this.descargar('LIQUIDACION', row.cuenta) }} href="#">Ver Liquidacion</a>
                  <a className="dropdown-item" onClick={() => { this.descargar('SOLICITUD', row.idSolicitud) }} href="#">Ver Solicitud</a>
                  <a className="dropdown-item" onClick={() => { this.descargar('CUOTERO', row.cuenta) }} href="#">Ver Cuotas</a>
                    {this.state.autorizador === 'S' && <a className="dropdown-item" onClick={() => { this.descargar('AUTORIZADOR', row.cuenta) }} href="#">Ver Autorizador</a>}
                </div>
              </div>
            }
            {row.numeroDestino !== 86 &&

              <div className="dropdown dropdownPi">
                <button onClick={() => { this.descargar('CUOTERO', row.cuenta) }} className="btn btn-cu-primary " type="button" id="dropdownMenuButton" aria-haspopup="true" aria-expanded="false">
                  Ver cuotas
                </button>

              </div>
            }
          </div>
        ),
      },
    ];
  }

  descargar = async (tipoReporte, idSolicitudCredito, montoConcedido) => {
    let data;
    if (tipoReporte === 'SOLICITUD') {
      data = {
        idSolicitud: idSolicitudCredito,
        tipoReporte
      }
    } else if (tipoReporte === 'CONTRATO') {
      data = {
        idCredito: idSolicitudCredito,
        montoSolicitado: Number(reemplazarPunto(montoConcedido)),
        tipoReporte
      }}
      else if (tipoReporte === 'AUTORIZADOR') {
      data = {
        idCredito: idSolicitudCredito,
        tipoReporte
      }
    } else {
      data = {
        idCredito: idSolicitudCredito,
        tipoReporte
      }
    }
    await trackPromise(
      PrestamoInmediatoService.obtenerReporte(data)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.error(error);
        })
    );
  };

  pagarPrestamo = (url, row) => {
    sessionStorage.setItem("prestamo", row.cuenta);
    sessionStorage.setItem("capital", row.capital);
    sessionStorage.setItem("moneda", row.moneda);
    sessionStorage.setItem("tipo", row.descripcion);

    var listadoPrestamos = this.props.prestamos;
    for (var i = 0; i < listadoPrestamos.length; i++) {
      if (listadoPrestamos[i].cuenta === row.cuenta) {
        sessionStorage.setItem("alDia", listadoPrestamos[i].alDia);
        break;
      }
    }

    history.push(url)

    window.location.reload();

  }


  render() {
    return (
      <DataTable
        noHeader={true}
        pagination={false}
        columns={this.getColumn()}
        data={this.props.prestamos}
        paginationComponentOptions={paginationOptions}
        noDataComponent="no hay registros para mostrar"
        responsive={true}
        pointerOnHover
        expandableRows
        striped={true}
        expandableRowsComponent={PrestamoCuota}
        progressPending={false}
      />

    );
  }
}